import { render, staticRenderFns } from "./PensionDetails.vue?vue&type=template&id=ca274fba&scoped=true"
import script from "./PensionDetails.vue?vue&type=script&lang=js"
export * from "./PensionDetails.vue?vue&type=script&lang=js"
import style0 from "./PensionDetails.vue?vue&type=style&index=0&id=ca274fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca274fba",
  null
  
)

export default component.exports